<template>
  <div class="advert-batch-page">
    <div class="search-user">
      <div class="el-search" style="border-radius: 0">
        <div class="el-right">
          <el-form
            ref="groupSearch"
            :model="search"
            :inline="true"
            label-width="10px"
            size="small"
            class="demo-form-inline el-input-height"
          >
            <el-form-item prop="userName">
              <el-input v-model="search.userName" :placeholder="$t('adverput.nickName')"></el-input>
            </el-form-item>
            <el-form-item prop="name">
              <el-input v-model="search.name" :placeholder="$t('adverput.name')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">{{ $t("common.search") }}</el-button>
              <el-button @click="handleReset" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="groupList"
      :empty-text="$t('common.noData')"
      :element-loading-text="$t('common.loading')"
      border
      style="width: 100%"
    >
      <el-table-column prop="nickName" :label="$t('adverput.nickName')" min-width="180" align="center"></el-table-column>
      <el-table-column prop="name" :label="$t('adverput.name')" min-width="180" align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('adverput.createTime')" width="180" align="center"></el-table-column>
      <el-table-column fixed="right" :label="$t('common.operate')" width="180" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            icon="el-icon-data-analysis"
            size="mini"
            @click="openBatchConfig(scope.row)"
            style="padding: 7px"
          >
            {{ $t("advertGroup.advertConfig") }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :current-page="page.pageIndex"
      :total="page.totalSize"
      :page-size="page.pageSize"
      @size-change="handleSizeChange"
      @current-change="loadGroups"
    ></el-pagination>

    <advert-config-dialog
      :visible="dialogVisible"
      mode="group"
      :team-id="currentGroup.id"
      :target-name="currentGroup.name"
      @close="handleDialogClose"
    ></advert-config-dialog>
  </div>
</template>

<script>
import advertConfigDialog from "_c/adverts/AdvertConfigDialog";

export default {
  name: "AdvertBatchDesktop",
  components: {
    advertConfigDialog
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      groupList: [],
      search: {
        userName: "",
        name: ""
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalSize: 0
      },
      currentGroup: {
        id: "",
        name: ""
      }
    };
  },
  mounted() {
    this.loadGroups();
  },
  methods: {
    loadGroups(pageIndex) {
      this.loading = true;
      this.page.pageIndex = pageIndex || this.page.pageIndex;
      this.$api
        .request(this.$url.UserMachineGroup.page, this.$method.get, {
          userName: this.search.userName,
          name: this.search.name,
          pageIndex: this.page.pageIndex,
          pageSize: this.page.pageSize
        })
        .then(res => {
          if (res.code === 0) {
            this.groupList = res.data.records;
            this.page.totalSize = Number(res.data.total);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.loadGroups(1);
    },
    handleReset() {
      this.search.userName = "";
      this.search.name = "";
      this.loadGroups(1);
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.loadGroups(1);
    },
    openBatchConfig(row) {
      this.currentGroup = {
        id: row.id,
        name: row.name
      };
      this.dialogVisible = true;
    },
    handleDialogClose(dialog, refresh) {
      this.dialogVisible = dialog;
      if (refresh) {
        this.loadGroups(this.page.pageIndex);
      }
    }
  }
};
</script>
